import React from 'react';
import './MilestoneIntCard.css';

function MilestoneIntCard(props) {
	const {
		mileStoneData,
		index,
		activeMilestone,
		activeState
	} = props;
	let overlayPercent = 100 - parseInt(mileStoneData?.percentage) + '%';
	return (
		<div className={'milestoneCard ' + (
			activeState === 'notStarted' ? 'notStarted'
				: activeState === 'ongoing' ? 'ongoing'
					: activeState === 'complete' ? 'completed'
						: activeMilestone === 'wining' ? 'wining' : '')}
			 key={index}
		>
			<div className="milestoneCardContent">
				<div className="milestoneCardHeader">
					<div className="h2">{mileStoneData?.heading}</div>
					<div className="h3">{
						activeState === 'complete' ? 'Complete':
							activeState === 'ongoing' ? mileStoneData?.text:
								activeMilestone === 'wining' ? 'Currently Winning' : ''}
					</div>
				</div>
				<div className="milestoneCardDrawer">
					<div className="milestoneCardInner">
						<img src={mileStoneData?.imgUrl} alt="milestoneImg"/>
						<span className="milestoneCardOverlay" style={{ width: overlayPercent }}></span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MilestoneIntCard;
